/**
 * @generated SignedSource<<20525b9fc1c5c88a4ef1d9b844bb17c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type uploadZone_PresignQuery$variables = {
  fileExtension: string;
  nonce: string;
};
export type uploadZone_PresignQuery$data = {
  readonly uploadPresign: {
    readonly signedUrl: string;
    readonly storageKey: string;
  } | null | undefined;
};
export type uploadZone_PresignQuery = {
  response: uploadZone_PresignQuery$data;
  variables: uploadZone_PresignQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "fileExtension"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nonce"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "fileExtension",
    "variableName": "fileExtension"
  },
  {
    "kind": "Variable",
    "name": "nonce",
    "variableName": "nonce"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "storageKey",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uploadZone_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uploadZone_PresignQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UploadPresign",
        "kind": "LinkedField",
        "name": "uploadPresign",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c31fc04e05b11207f2dd6e18432be345",
    "id": null,
    "metadata": {},
    "name": "uploadZone_PresignQuery",
    "operationKind": "query",
    "text": "query uploadZone_PresignQuery(\n  $fileExtension: String!\n  $nonce: String!\n) {\n  uploadPresign(fileExtension: $fileExtension, nonce: $nonce) {\n    signedUrl\n    storageKey\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d0b6e2b9ff670af05c17e2598f6aefb";

export default node;
